/* Built In Imports */
import React, { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import Breadcrum from '@components/Navigation/Breadcrum';
import EventsCommonUI from '@components/UI/Events/EventsCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData,
    fetchHeaderMenuData,
    fetchHeaderTopMenuData,
    filterBuildUrls,
    getLatestBuild,
} from 'services/commonService';
import { fetchDetails, fetchMMMGeoContentData } from 'services/mmmeventService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Events Landing Page Data
 */
const MMMLondonPage = ({ region, language, pageData, page }) => {
  const [programData, setProgramData] = useState('');

  useEffect(() => {
    localData();
  }, [region, language]);

  const localData = async () => {
    let programData = await fetchMMMGeoContentData(region, language);
    // let programData = {
    //   jsonrpc: '2.0',
    //   id: null,
    //   result: '<Response 283 bytes [500 INTERNAL SERVER ERROR]>',
    // };
    // let programData = {
    //   jsonrpc: '2.0',
    //   id: null,
    //   result: [
    //     {
    //       id: 415,
    //       name: 'Sadhguru in London',
    //       url_registration:
    //         'https://preprod-online.sadhguru.org/event-register?event=sadhguru-in-london-415&country_code=IN',
    //       url_enquiry:
    //         'https://preprod-online.sadhguru.org/program-lead?event_type=meet,-mingle-and-meditate-with-sadhguru,-london&disable_program_selection=true',
    //       start_date: '2023-06-18 07:30:00',
    //       end_date: '2023-06-18 12:30:00',
    //       seats_available: 99999,
    //       max_per_booking: 10,
    //       tickets: [
    //         {
    //           id: 663,
    //           name: 'Donor A',
    //           seats_available: 0,
    //           start_date: false,
    //           end_date: false,
    //           price: 1000.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //         {
    //           id: 781,
    //           name: 'Donor B',
    //           seats_available: 99999,
    //           start_date: false,
    //           end_date: false,
    //           price: 500.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //         {
    //           id: 665,
    //           name: 'Section 1',
    //           seats_available: 0,
    //           start_date: false,
    //           end_date: false,
    //           price: 115.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //         {
    //           id: 782,
    //           name: 'Section 2',
    //           seats_available: 99999,
    //           start_date: false,
    //           end_date: false,
    //           price: 65.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //         {
    //           id: 783,
    //           name: 'Section 3',
    //           seats_available: 99999,
    //           start_date: false,
    //           end_date: false,
    //           price: 35.0,
    //           currency: 'GBP',
    //           person_count: 1,
    //           is_expired: false,
    //         },
    //       ],
    //       batches: [],
    //       venue: {
    //         street: false,
    //         street_2: false,
    //         city: false,
    //         state: false,
    //         country: false,
    //         country_code: false,
    //         zip: false,
    //       },
    //       queried_country_code: 'FR',
    //       regional_support_email: false,
    //       regional_support_phone: false,
    //       regional_notes: false,
    //       is_registration_allowed: false,
    //     },
    //   ],
    // };
    setProgramData(programData);
    // console.log('csrData', programData);
  };
  // console.log('csrData', programData);

  return (
    <WrapLayout pad={0}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" className="page-wrap container-article" p="0">
        <EventsCommonUI
          pageBody={pageData.body}
          region={region}
          lang={language}
          csrData={programData}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let mmmLandingPaths =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.MMMLondon
      ? [
          '/in/en/events/special-events/sadhguru-in-london-jun-2023',
          '/global/fr/events/special-events/sadhguru-in-london-jun-2023',
          '/uk/en/events/special-events/sadhguru-in-london-jun-2023',
        ]
      : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    mmmLandingPaths = filterBuildUrls(
      'landing_pages',
      'L2',
      '/events/special-events/sadhguru-in-london-jun-2023',
      '',
      data
    );
  }
  return {
    paths: mmmLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language);
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'MMMLondon',
    },
  };
};

export default MMMLondonPage;
